<template>
  <section class="product-list" v-if="list.length">
    <div class="product-item_wrapper" v-for="item in list" :key="item.id">
      <!-- 非促销商品 -->
      <product-item v-bind="$attrs" @change="onChange" v-if="!(item instanceof Array)" :item="item" :checkbox="checkbox"></product-item>
      <!-- 促销商品 -->
      <div v-else class="product-package">
        <product-item v-bind="$attrs" @change="onChange" v-for="good in item" :key="good.id" :item="good" :checkbox="checkbox"></product-item>
        <div class="package">
          <div class="package-left">
            <div class="package-tip">
              套餐
            </div>
            <div class="package-price">
              ￥{{(+item[0].price).toFixed(4)}}
            </div>
          </div>
          <div class="package-right">
            <div class="package-number">
              购买数量：{{item[0].quantity}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ProductItem from './product-item'
export default {
  name: 'product-list',
  components: {
    ProductItem
  },
  props: {
    /**
     * @description 商品数据
     */
    list: {
      type: Array,
      default: () => []
    },
    /**
     * @description 是否展示 checkbox
     */
    checkbox: {
      default: false
    }
  },
  data () {
    return {}
  },
  methods: {
    onChange (item) {
      this.$emit('change', item)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/var.scss';
@import '~styles/mixins.scss';
.product-list {
  margin-top: 8px;
  background: #fff;
  // box-shadow: $box-shadow-base;
  .package {
    @include flex(row);
    justify-content: space-between;
    height: 40px;
    padding: 0 10px;
    border: 1px solid $border-color-base;
    border-left: 0;
    border-right: 0;
    &-tip {
      background: red;
      color: #fff;
      padding: 3px 8px;
    }
    &-price {
      color: $price-color;
      font-size: 14px;
      padding-left: 10px;
    }
    &-left, &-right {
      @include flex(row);
      align-items: center;
    }
  }
  .product-package {
    border-top: 1px solid $border-color-base;
  }
}
</style>
